import { createAction } from 'redux-api-middleware';
import { push } from 'connected-react-router';
import { omit } from 'lodash';
import { decamelizeKeys } from 'humps';

import Routes from 'utils/routes.js.erb';
import { API_FAILURE, authHeaders } from 'actions';
import { tranformSuccessPayload } from 'actions/transformers';
import { getQueryFromParams } from 'utils/query';
import { selectProgramContentLibraryMeta } from './selectors';

const READ_ONLY_META_PROPERTIES = [
  'per',
  'totalCount',
  'totalPages',
];

export const PROGRAM_CONTENT_ENTRIES_REQUEST = 'PROGRAM_CONTENT_ENTRIES_REQUEST';
export const PROGRAM_CONTENT_ENTRIES_RECEIVE = 'PROGRAM_CONTENT_ENTRIES_RECEIVE';

export const fetchProgramContentEntries = (params) => createAction({
  endpoint: Routes.api_dashboard_program_content_entries_path(decamelizeKeys(params)),
  headers: authHeaders(),
  method: 'GET',
  types: [
    PROGRAM_CONTENT_ENTRIES_REQUEST,
    tranformSuccessPayload(PROGRAM_CONTENT_ENTRIES_RECEIVE),
    API_FAILURE,
  ],
  fetch: fetch,
});

export const updateProgramContentMeta = (newMeta) => {
  return (dispatch, getState) => {
    const state = getState();
    const meta = selectProgramContentLibraryMeta(state);

    const params = omit({
      ...meta,
      ...newMeta,
    }, READ_ONLY_META_PROPERTIES);

    dispatch(push({
      search: getQueryFromParams(params)
    }));

    dispatch(fetchProgramContentEntries(params));
  };
};


export const updateProgramContentFilters = (newFilters) => {
  return updateProgramContentMeta({
    ...newFilters,
    page: 1,
  });
}
